var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{attrs:{"label":_vm.label,"disabled":_vm.disabled},on:{"change":_vm.onChangedInternal},model:{value:(_vm.model[_vm.prop]),callback:function ($$v) {_vm.$set(_vm.model, _vm.prop, $$v)},expression:"model[prop]"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }